import { ShopifyLineItemProperties, ShopifyLineItem } from "types";
import { FetchHelperError, fetchSymbol } from "../fetch/fetch-helper";
import { z } from "zod";
import { formatZodError } from "../../utils/zod-error";

const endpoint = '/cart/add.js';

const AddProductParamsSchema = z.object({
  id: z.number(),
  quantity: z.number(),
  properties: z.record(z.any()).optional(),
  selling_plan: z.number().optional(),

});

interface AddProductResponse {
  items: ShopifyLineItem[]
}

const AddProductsParamsSchema = AddProductParamsSchema.array();

type AddProductParams<T extends ShopifyLineItemProperties> = z.infer<typeof AddProductParamsSchema> & { properties: T };

export async function add<T extends ShopifyLineItemProperties>(params: AddProductParams<T> | AddProductParams<T>[], noIntercept?: boolean): Promise<AddProductResponse> {
  let items = (Array.isArray(params)) ? params : [params];
  const result = AddProductsParamsSchema.safeParse(items);
  if (!result.success) throw new TypeError(`Couldn't add to cart due to invalid params: ${formatZodError(result.error)}`);
  const response = await window[fetchSymbol].postJSON<{ items: ShopifyLineItem[] }>(endpoint, { items }, noIntercept);
  return response;
}
